import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import {
  HelpBlock,
  FormGroup,
  Glyphicon,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { Colors }   from "../../utils/Colors";
import config       from "../../config";
import LoaderButton from "../../components/LoaderButton";
import "../../css/utils/ResetPassword.css";

export default class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
      email: "",
      password: "",
      codeSent: false,
      confirmed: false,
      confirmPassword: "",
      isConfirming: false,
      isSendingCode: false,
      reenterEmail: false
    };
  }

  validateCodeForm() {
      return this.state.email.length > 0;
  }

  validateResetForm() {
     /* if(this.state.reenterEmail) {
        return (
            this.state.email.length > 0 &&
            this.state.code.length > 0 &&
            this.state.password.length > 0 &&
            this.state.password === this.state.confirmPassword
        );
        } else {*/
        return (
            this.state.code.length > 0 &&
            this.state.password.length > 0 &&
            this.state.password === this.state.confirmPassword
        );
    //}
  }

  handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
  };

  handleSendCodeClick = async event => {
        event.preventDefault();

        this.setState({ isSendingCode: true });

        try {
          await Auth.forgotPassword(this.state.email);
          this.setState({ codeSent: true });
        } catch (e) {
            for(var key in e) {
                console.log("key: " + key);
                console.log("err: " + e[key]);
            }
            alert("Send code error: " + e.message);
            this.setState({ isSendingCode: false });
        }
  };

  handleConfirmClick = async event => {
        event.preventDefault();

        this.setState({ isConfirming: true });

        try {
          await Auth.forgotPasswordSubmit(
            this.state.email,
            this.state.code,
            this.state.password
          );
          this.setState({ confirmed: true });
        } catch (e) {
            for(var key in e) {
                console.log("key: " + key);
                console.log("err: " + e[key]);
            }
            alert("Send code error: " + e.message);
            this.setState({ isConfirming: false });
        }
  };

  handleLinkToConfirmCode = async event => {
      console.log("link confirm");
     // event.preventDefault();
      this.setState({
          confirmed: false,
          codeSent: true,
          reenterEmail: true
      });
      this.renderConfirmationForm();
     /* this.setState({
          confirmed: true
      })*/
  }

  renderRequestCodeForm() {

      return (
          <form onSubmit={this.handleSendCodeClick}>
              <FormGroup bsSize="large" controlId="email">
                  <ControlLabel className="loginTFLabels">Email</ControlLabel>
                  <FormControl
                      className="resetEmail"
                      autoFocus
                      type="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                  />
              </FormGroup>
              <LoaderButton
                  block
                  type="submit"
                  bsSize="large"
                  loadingText="Sending…"
                  text="Send Confirmation"
                  btncolor = { Colors.ok_button_bg }
                  fontSize={20}
                  height  = {40}
                  isLoading={this.state.isSendingCode}
                  disabled={!this.validateCodeForm()}
              />
              <div onClick={this.handleLinkToConfirmCode}
                  className="signupConfirmationCodeLink">
                  <br/>
                  Enter confirmation code
              </div>
          </form>
    );
  }

  renderConfirmationForm() {
      var help_text = "Please check your email ("+this.state.email+") for the confirmation code.";
      var email_tf;

      if(this.state.reenterEmail) {
          email_tf =  <FormGroup controlId="email" bsSize="large">
                         <ControlLabel className="loginTFLabels">Email</ControlLabel>
                         <FormControl
                             className="signupEmail"
                             autoFocus
                             type="email"
                             value={this.state.email}
                             onChange={this.handleChange}
                         />
                       </FormGroup>
          help_text = "";
      }

        return (
          <form onSubmit={this.handleConfirmClick}>
            <FormGroup bsSize="large" controlId="code">
                { email_tf }
                <ControlLabel className="loginTFLabels">Confirmation Code</ControlLabel>
                <FormControl
                    autoFocus
                    type="tel"
                    value={this.state.code}
                    onChange={this.handleChange}
                />
                <HelpBlock>
                    { help_text }
                </HelpBlock>
            </FormGroup>
            <hr />
            <FormGroup bsSize="large" controlId="password">
                <ControlLabel className="loginTFLabels">New Password</ControlLabel>
                <FormControl
                    type="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                />
            </FormGroup>
            <FormGroup bsSize="large" controlId="confirmPassword">
                <ControlLabel className="loginTFLabels">Confirm Password</ControlLabel>
                <FormControl
                    type="password"
                    onChange={this.handleChange}
                    value={this.state.confirmPassword}
                />
            </FormGroup>
            <LoaderButton
                block
                type="submit"
                bsSize="large"
                text="Confirm"
                loadingText="Confirm…"
                btncolor = { Colors.ok_button_bg }
                fontSize={20}
                height  = {40}
                isLoading={this.state.isConfirming}
                disabled={!this.validateResetForm()}
            />
          </form>
        );
  }

  renderSuccessMessage() {
    return (
      <div className="success">
        <Glyphicon glyph="ok" />
        <p>Your password has been reset.</p>
        <p>
          <Link to="/login">
            Click here to login with your new credentials.
          </Link>
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className="ResetPassword">
        { !this.state.codeSent ? this.renderRequestCodeForm() :
            !this.state.confirmed ? this.renderConfirmationForm() : this.renderSuccessMessage()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/utils/ResetPassword.js